
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|3021|3419|4051)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
